import axios from "axios";
import { API_GATEWAY_URL } from "../config/constants";

export const sentNewsletter = async (event_id: string,email:string) => {
   try {
      const res=await axios.post(`${API_GATEWAY_URL}frontend/api/landing-page/newsletter`,{
        event_id,
        email
      })
      return res.data.status
    } catch (error) {
      console.error(error);
    }
};

export const getPartners = async (event_id: string) => {
   try {
      const res=await axios.get(`${API_GATEWAY_URL}frontend/api/landing-page/event-id/${event_id}/partners`)
      return res.data
    } catch (error) {
      console.error(error);
    }
};